import {
    snakeCase,
    text,
    timestamp,
    varchar,
    integer,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { categoryStatusEnum } from './_common.table'
import { serviceProviderCategoriesTable } from './service-provider-categories.table'

export const benefitSubCategoriesTable = snakeCase.table(
    'benefit_sub_categories',
    {
        id: id('spc'),
        categoryId: text()
            .references(() => serviceProviderCategoriesTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            })
            .notNull(),
        name: varchar({ length: 150 }).notNull().unique(),
        slug: varchar({ length: 150 }).notNull().unique(),
        description: text(),
        status: categoryStatusEnum().notNull().default('active'),
        sortOrder: integer().notNull().default(0),
        deletedAt: timestamp({ withTimezone: true }),
        ...timestamps,
    },
)
